import generateCertificateTranslation from './index.json';

export default generateCertificateTranslation;
